import { useEffect, useState } from "react";
import { IP_DATA_KEY } from "../constants/misc";
import { CitySearchResultWithCateg, Location } from "../custom-types/location-search";
import { getCurrentLocation } from "../methods/getCurrentLocation";
import { useCsDashboard } from "./useCsDashboard";
import { LocationSearchParamsOption, searchUsingPlacesAPI } from "../_services/city-search.service";

export function useGetCurrentLocation() {
    const { isCsDashboardUser } = useCsDashboard();
    const getAndSetCurrentLocation = async (paramsOption: LocationSearchParamsOption) => {
        if (isCsDashboardUser) {
            return;
        }
        const locDataRes = await fetch(`https://api.ipdata.co?api-key=${IP_DATA_KEY}`);
        if (locDataRes.status === 200) {
            const locData = await locDataRes.json();
            const { name, id, state, state_id, state_code }: CitySearchResultWithCateg = (
                await searchUsingPlacesAPI(locData.city, paramsOption)
            )[0];
            const currLocObj: Location = {
                status: "done",
                lat: locData.latitude,
                lng: locData.longitude,
                id,
                name,
                state,
                state_id,
                state_code
            };
            // setCurrentLocation?.(currLocObj);
            return currLocObj;
        }
        // if (!currentLocation) {
        //     const savedLoc = JSON.parse(window.localStorage.getItem("currentLocation") || "null") as Location;
        //     if (savedLoc) {
        //         setCurrentLocation?.({
        //             lat: savedLoc.lat,
        //             lng: savedLoc.lng,
        //             city: savedLoc.city,
        //             state: savedLoc.state
        //         });
        //     } else {
        // window.navigator.geolocation.getCurrentPosition(
        //     ({ coords }) => {
        //         setCurrentLocation?.({ lat: coords.latitude, lng: coords.longitude, status: "done" });
        //         // window.localStorage.setItem(
        //         //     "currentLocation",
        //         //     JSON.stringify({ lat: coords.latitude, lng: coords.longitude })
        //         // );
        //     },
        //     () => {
        //         setCurrentLocation?.({ status: "denied" });
        //         toast.error("Please enable location permission from settings and try again!", {
        //             position: "top-center",
        //             draggable: false,
        //             transition: Slide
        //         });
        //     }
        // );
        // }
        // }
    };

    return { getAndSetCurrentLocation };
}

interface GetCurrentLocationOnPageLoadParams {
    enabled?: boolean;
    locationSearchParams: LocationSearchParamsOption;
}

export function useGetCurrentLocationOnPageLoad({
    enabled = true,
    locationSearchParams
}: GetCurrentLocationOnPageLoadParams) {
    const { isCsDashboardUser } = useCsDashboard();
    // const { setCurrentLocation } = useContext(AppContext);
    const [currLoc, setCurrLoc] = useState<CitySearchResultWithCateg>();
    // const { getAndSetCurrentLocation } = useGetCurrentLocation();
    useEffect(() => {
        // setCurrentLocation?.({ status: "loading" });
        if (!enabled || isCsDashboardUser) {
            return;
        }
        (async () => {
            const res = await getCurrentLocation(false, locationSearchParams);
            setCurrLoc(res);
        })();
        // if (navigator.permissions) {
        //     navigator.permissions.query({ name: "geolocation" }).then((status) => {
        //         if (status.state === "granted") {
        //             setCurrentLocation?.({ status: "loading" });
        //             getAndSetCurrentLocation();
        //         }
        //     });
        // } else {
        //     // for Safari
        //     setCurrentLocation?.({ status: "loading" });
        //     getAndSetCurrentLocation();
        // }

        // // window.navigator.geolocation. getAndSetCurrentLocation();
    }, [enabled, isCsDashboardUser]);
    return currLoc;
}
